export const ID = '222ac837-644a-4d07-8090-5974ec51a3d8';

export const NAME = 'Accordion';
